module.exports = __webpack_public_path__ + "img/blog-22-1.54b322d5.webp";